import { useAuth } from "@agentech/auth-client";
import { Navigate, useLocation } from "react-router-dom";
import { useAdmin } from "./AdminContext";

interface AdminGuardProps {
  children: React.ReactNode;
  requireSuperAdmin?: boolean;
}

export function AdminGuard({ children, requireSuperAdmin = false }: AdminGuardProps) {
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const { isAdmin, admin, isLoading: adminLoading } = useAdmin();
  const location = useLocation();

  // Show loading while checking auth and admin status
  if (authLoading || adminLoading) {
    return (
      <div className="admin-loading">
        <div className="loading-spinner" />
        <p>Checking permissions...</p>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Show forbidden if not admin
  if (!isAdmin) {
    return (
      <div className="admin-forbidden">
        <h1>Access Denied</h1>
        <p>You do not have permission to access the admin area.</p>
        <a href="/">Return to Home</a>
      </div>
    );
  }

  // Check super admin requirement
  if (requireSuperAdmin && admin?.role !== "super_admin") {
    return (
      <div className="admin-forbidden">
        <h1>Access Denied</h1>
        <p>This area requires super admin privileges.</p>
        <a href="/admin">Return to Admin Dashboard</a>
      </div>
    );
  }

  return <>{children}</>;
}
